import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAppTheme } from '../../contexts/ThemeContext';

/**
 * Segmented TR / EN language toggle.
 */
export const LanguageToggle = ({ className = '' }) => {
  const { language, changeLanguage } = useLanguage();

  const segment = (lang, label) => {
    const active = language === lang;
    return (
      <button
        type="button"
        onClick={() => changeLanguage(lang)}
        aria-pressed={active}
        className={`px-2.5 py-1 text-xs font-semibold rounded-full transition-colors ${
          active
            ? 'bg-[#24299d] text-white shadow-sm'
            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
        }`}
      >
        {label}
      </button>
    );
  };

  return (
    <div className={`inline-flex items-center gap-0.5 p-0.5 rounded-full bg-gray-100 dark:bg-white/10 ${className}`}>
      {segment('tr', 'TR')}
      {segment('en', 'EN')}
    </div>
  );
};

/**
 * Circular dark / light mode toggle button.
 */
export const ThemeToggle = ({ className = '' }) => {
  const { darkMode, toggleTheme } = useAppTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={darkMode ? 'Light mode' : 'Dark mode'}
      title={darkMode ? 'Light mode' : 'Dark mode'}
      className={`w-8 h-8 inline-flex items-center justify-center rounded-full bg-gray-100 dark:bg-white/10 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white transition-colors ${className}`}
    >
      {darkMode ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
};
